<template>
    <!-- parameter | sport radar api key -->
    <div class="p-grid p-jc-center p-p-4">
      <div class="card p-col-12 p-md-9 p-mx-auto p-p-4">
        <div class="p-grid">
          <div class="p-col-12 p-md-6">
            <span class="p-float-label">
                <InputText id="tableName" style="width:100%" type="text" v-model="parameter.tableName" disabled />
                <label for="tableName">Table Name</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6">
            <span class="p-float-label">
                <InputText id="key" style="width:100%" type="text" v-model="parameter.key" disabled />
                <label for="key">Key</label>
            </span>
          </div>
          <div class="p-col-12 p-md-12 p-mt-3">
            <span class="p-float-label">
                <InputText id="value" style="width:100%" type="text" v-model="parameter.value" />
                <label for="value">Value</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
                <Calendar inputId="startDate" style="width:100%"
                    v-model="parameter.startDate"
                    :minDate="new Date()"
                    :showSeconds="false" :showTime="false"
                    dateFormat="dd-mm-yy" />
                <label for="startDate">Start date</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
                <Calendar inputId="endDate" style="width:100%"
                    v-model="parameter.endDate"
                    :minDate="new Date()"
                    :showSeconds="false" :showTime="false"
                    dateFormat="dd-mm-yy" />
                <label for="endDate">End date</label>
            </span>
          </div>
          <div class="p-col-12 p-md-12 p-mt-1">
                <Textarea class="resizable_textarea" style="width:100%; line-height: 1.5em;" id="comment" 
                    placeholder="Comment" rows="2" :autoResize="true" v-model="parameter.comment" />
          </div>
        </div>
        <div class="p-grid p-jc-end p-m-0 p-pt-2">
          <Button label="Save" class="p-button-raised p-button" @click="save()" />
        </div>
      </div>
    </div>

</template>

<script>
/* eslint-disable-next-line no-unused-vars */

import axios from "axios";
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Calendar from 'primevue/calendar'
import Textarea from 'primevue/textarea'
import moment from 'moment'

import { isEmpty } from '../../utils/utils'

let SpringApi;

export default {
    name: 'ParametersSportRadarApiKey',
    components: {
        Button, InputText, Calendar, Textarea
    },
    data() {
        return {
            parameter: {
                tableName: 'SPORT_RADAR',
                key: 'SOCCER_API_KEY',
                isLoading: false,
                id: null,
                value: null,
                comment: null,
                startDate: null,
                endDate: null,
            },
        }
    },
    emits: ["loginResult", "pageLoaded"],
    beforeMount() {
        SpringApi = axios.create({
            baseURL : process.env.VUE_APP_SPRING_API_URL,
            headers: {
                'Authorization': 'Bearer ' + this.$cookies.get('token')
            }
        });

        var page = {
            title: 'Parameters | Sport Radar Api Key'
        }
        this.$emit('pageLoaded', page)
    },
    mounted() {
        this.getParameter()
    },
    methods: {
        async getParameter() {
            let self = this,
                parameter = self.parameter,
                toast = self.$toast;

            try {
                parameter.isLoading = true

                let response = await SpringApi.get('/parameters/search', {
                    params: {
                        tableName: this.parameter.tableName,
                        key: this.parameter.key
                    }
                })

                let paramApiKey = response.data
                let optionalParameters = paramApiKey.optionalParameters

                self.parameter.id = paramApiKey.id
                self.parameter.startDate = moment(optionalParameters.startDate, "DD-MM-YYYY").toDate()
                self.parameter.endDate = moment(optionalParameters.endDate, "DD-MM-YYYY").toDate()
                self.parameter.value = paramApiKey.value
                self.parameter.comment = paramApiKey.comment
            } catch(error) {
                console.log(error)
                toast.add({severity:'error', summary: 'Error', detail:error});
            } finally {
                parameter.isLoading = false
            }
        },
        async save() {
            let self = this,
                parameter = self.parameter,
                toast = self.$toast,
                value = this.parameter.value,
                startDate = this.parameter.startDate,
                endDate = this.parameter.endDate,
                error = "";

            if (isEmpty(value)) {
                error = "Value can not be empty";
            } else if (isEmpty(startDate)) {
                error = "Start date can not be empty";
            } else if (isEmpty(endDate)) {
                error = "End date can not be empty";
            }
            
            if (!isEmpty(error)) {
                toast.add({severity:'error', summary: 'Error', detail: error});
                return
            }

            try {
                parameter.isLoading = true

                let response = await SpringApi.put('/parameters/'+parameter.id, {
                    tableName: this.parameter.tableName,
                    key: this.parameter.key,
                    value: value,
                    comment: this.parameter.comment,
                    optionalParameters: {
                        startDate: moment(startDate).format('DD-MM-YYYY'),
                        endDate: moment(endDate).format('DD-MM-YYYY'),
                    }
                })

                if(response.status >= 200 && response.status <= 299) {
                    toast.add({severity:'success', summary: 'Parameter updated', detail:response.data.mesaj, life: 1000});
                } else {
                    console.log(response)
                    toast.add({severity:'warn', summary: 'Parameter update failed', detail:response.data.mesaj, life: 3000});
                }
            } catch(error) {
                console.log(error)
                toast.add({severity:'error', summary: 'Error', detail:error});
            } finally {
                parameter.isLoading = false
            }
        }
    }
}
</script>
